import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faEraser } from '@fortawesome/free-solid-svg-icons';
import TreeVisualization from '../components/TreeVisualization';

const exampleJson = {
  "squadName": "Super hero squad",
  "homeTown": "Metro City",
  "formed": 2016,
  "secretBase": "Super tower",
  "active": true,
  "members": [
    {
      "name": "Molecule Man",
      "age": 29,
      "secretIdentity": "Dan Jukes",
      "powers": [
        "Radiation resistance",
        "Turning tiny",
        "Radiation blast"
      ]
    }
  ]
}

const JsonVisualizer = (props) => {
  const { editorTheme } = props
  const [originalInput, setOriginalinput] = useState(JSON.stringify(exampleJson, null, 2));
  const [stringOutput, setStringOutput] = useState(null);
  const [counter, setCounter] = useState(0)

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalinput(content);
    };
    reader.readAsText(file);
  };

  useEffect(() => {
    if (originalInput === "") {
      setStringOutput("");
    } else {
      const jsonObject = JSON.parse(originalInput);
      setStringOutput(jsonObject)
    }
  }, [originalInput])

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>JSON Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <Editor 
              height="40vh"
              value={originalInput}
              onChange={(value, event) => setOriginalinput(value)}
              placeholder="Please enter JSON code."
              defaultLanguage="json"
              defaultValue={originalInput}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <input
              type="file"
              accept='.json'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              type="button"
              onClick={() => document.querySelector('input[name="file1"]').click()}
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your JSON file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalinput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-full">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>JSON Visualize</h3>
          </div>
          { stringOutput && (
           <div style={{ height: '100vh', width: '100vw' }}>
            <TreeVisualization key={counter} data={stringOutput} />
          </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default JsonVisualizer;
